import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import ImportCheckInPlan from 'app/containers/CustomerCare/ImportCheckInPlan'

const CheckInCustomerCarePlanPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.customer_care_plan)}</PageTitle>
      <ImportCheckInPlan />
    </>
  )
}
const CheckInCustomerCarePlanPage = memo(CheckInCustomerCarePlanPageCpn, isEqual)

export default CheckInCustomerCarePlanPage
